import { Dropdown as BTDropdown, DropdownButton } from "react-bootstrap";
import PropTypes from "prop-types";
import classNames from "classnames";
import { IconArrowDown } from "assets/icons";
import { DropdownContainer } from "./Dropdown.styles";

export const Dropdown = (props) => {
  const {
    title = null,
    options = [],
    onButtonClick = null,
    onOptionClick = null,
    disabled = false,
    divider = true,
    showChevron = false,
    Option,
    handleMouseLeave,
    children,
    ...otherProps
  } = props;

  return (
    <DropdownContainer
      className={classNames({
        disabled: disabled,
      })}
    >
      {children}
      <DropdownButton
        id="dropdown-button"
        onClick={onButtonClick}
        title={
          title !== null ? (
            <>
              {title}
              {showChevron && <IconArrowDown fill="#717184" />}
            </>
          ) : null
        }
        disabled={disabled}
        {...otherProps}
      >
        <div onMouseLeave={handleMouseLeave}>
          {options.map((option, i) => {
            return (
              <div
                key={option.key ? option.key : i}
                className={classNames({
                  "selected-option": title == option.key,
                })}
              >
                <BTDropdown.Item
                  eventKey={option.id}
                  disabled={option?.disabled}
                  onClick={(e) => onOptionClick(option, e)}
                >
                  {!Option && (
                    <>
                      {option.icon && (
                        <span className="icon">{option.icon}</span>
                      )}
                      <span className="title">{option.title}</span>
                    </>
                  )}
                  {Option && <Option {...option} />}
                </BTDropdown.Item>
                {options.length - 1 !== i && divider && <BTDropdown.Divider />}
              </div>
            );
          })}
        </div>
      </DropdownButton>
    </DropdownContainer>
  );
};

Dropdown.propTypes = {
  title: PropTypes.any,
  align: PropTypes.oneOf(["start", "end"]),
  options: PropTypes.array,
  onOptionClick: PropTypes.func,
  onButtonClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  divider: PropTypes.bool,
  children: PropTypes.node,
  Option: PropTypes.func,
  svgIcon: PropTypes.func,
  handleMouseLeave: PropTypes.func,
  showChevron: PropTypes.bool,
};
